
import * as React from "react";
import ReactMomentCountDown from 'react-moment-countdown';
interface IProfessionalRowProps {
    item: any
    selectProfessionalProfile?: Function
}

interface IProfessionalRowState {}



export default class ProfessionalRow extends React.Component<IProfessionalRowProps, IProfessionalRowState>{

    constructor(props:IProfessionalRowProps){
        super(props);
        this.state = {
        };


    }

    private toggleLikeClickHandler(evt, restaurantId:number, index:number): void {
        evt.preventDefault();
        /*if ( Api.isFrontUser() ) {
            Api.call('/user/restaurant/toggleLike', {
                restaurantId: restaurantId
            }, (result) =>{
                if ( result.success === true ) {
                    let items = this.state.items;
                    if ( this.props.justLiked !== undefined && this.props.justLiked === true ) {
                        items.splice(index, 1);
                    }else{
                        items[index].liked = !items[index].liked;
                    }
                    this.setState({
                        items: items
                    });
                }
            });
        }*/
    }

    private openRestaurantClickHandler(evt, id:number): void {
        evt.preventDefault();
        this.props.selectProfessionalProfile(id);


    }

    render() {

        let item = this.props.item;

        return (
            <div className = "professional_row" onClick={e => this.openRestaurantClickHandler(e, item.id)}>
                <div className = "image">
                    {
                        item.offer[0].creator.photos?.profilePhoto.length > 0 &&
                        <img src={item.offer[0].creator.photos?.profilePhoto} />
                    }
                </div>

                <div className = "content">
                    <p className = "name">{item.name}</p>
                    <div className = "info">
                        <p>{item.distance} - available: <br></br>{item?.offer[0]?.freeDate}</p>
                    </div>
                    {
                        item.rateing > 0 &&
                        <span className="rateing_star_inline_box">
                            { item.rateing >= 1?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                            { item.rateing >= 2?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                            { item.rateing >= 3?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                            { item.rateing >= 4?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                            { item.rateing >= 5?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                        </span>
                    }
                </div>
                <a className="like_box" onClick={ (e) => { this.toggleLikeClickHandler(e, item.id, item.id); } }>
                    { item.liked === true ?
                        <img src="img/unlike_icon.svg" width={24} alt=""/>:
                        <img src="img/like_icon.svg" width={24} alt=""/>
                    }
                </a>
            </div>

        );
    }
}
